<div class="container-fluid">
	<div class="row align-items-end my-3">
		<div class="col">
			<h1 class="text-capitalize">Impresoras USB</h1>
		</div>
		<div class="col-auto">
			<button type="button" class="btn btn-success me-2" (click)="pairNewDevice($event)">
				Emparejar impresora
			</button>
			<button type="button" class="btn btn-secondary lift" [routerLink]="['/add-printer-config']">Agregar</button>
		</div>
	</div>

	<div class="card p-3 mb-3" *ngIf="paired_devices.length > 0">
		<h5>Impresoras Emparejadas ({{ paired_devices.length }})</h5>
		<div class="table-responsive">
			<table class="table table-sm mb-0">
				<thead>
					<tr>
						<th>Nombre</th>
						<th>Fabricante</th>
						<th>Vendor ID</th>
						<th>Product ID</th>
						<th>Serial</th>
						<th>Configurada</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let device of paired_devices">
						<td>{{ device.productName || 'Desconocido' }}</td>
						<td>{{ device.manufacturerName || '-' }}</td>
						<td><code>{{ formatVendorId(device.vendorId) }}</code></td>
						<td><code>{{ formatVendorId(device.productId) }}</code></td>
						<td>{{ device.serialNumber || '-' }}</td>
						<td>
							<span *ngIf="isDeviceConfigured(device)" class="badge bg-success">Si</span>
							<span *ngIf="!isDeviceConfigured(device)" class="badge bg-warning text-dark">
								<a class="text-reset" [routerLink]="['/add-printer-config']" [queryParams]="{vendor_id: formatVendorId(device.vendorId), product_id: formatVendorId(device.productId)}">Configurar</a>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="alert alert-info" *ngIf="paired_devices.length === 0">
		No hay impresoras emparejadas. Haga clic en "Emparejar impresora" y seleccione su impresora USB.
	</div>

	<app-pagination [path]="'/list-printer-config'" [pages]="pages" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>

	<div class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<div class="table-responsive">
			<table class="table mb-0">
				<thead class="thead-light">
					<tr>
						<th class="px-1 pointer" (click)="this.sort('name', this.printer_search)">Nombre</th>
						<th class="px-1 pointer" (click)="this.sort('store_id', this.printer_search)">Sucursal</th>
						<th class="px-1 d-none d-md-table-cell">Modelo</th>
						<th class="px-1 d-none d-lg-table-cell">Calculo</th>
						<th class="px-1 d-none d-lg-table-cell">USB</th>
						<th class="px-1 d-none d-lg-table-cell text-end pointer" (click)="this.sort('updated', this.printer_search)">Actualizado</th>
						<th class="px-1 text-end">Uso</th>
						<th class="px-1 text-end">Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let printer of printer_list">
						<td class="px-1">
							<a [routerLink]="['/edit-printer-config', printer.id]">{{ printer.name | titlecase }}</a>
						</td>
						<td class="px-1">{{ getStoreName(printer.store_id) }}</td>
						<td class="px-1 d-none d-md-table-cell">{{ printer.model }}</td>
						<td class="px-1 d-none d-lg-table-cell">
							<span class="badge" [ngClass]="printer.calculation_style === 'SAT_FACTURA' ? 'bg-info' : 'bg-secondary'">
								{{ printer.calculation_style === 'SAT_FACTURA' ? 'SAT' : 'Normal' }}
							</span>
							<span *ngIf="printer.compact_items" class="badge bg-warning text-dark ms-1">Compacto</span>
						</td>
						<td class="px-1 d-none d-lg-table-cell">
							<span *ngIf="isDevicePaired(printer)" class="badge bg-success">Emparejada</span>
							<span *ngIf="!isDevicePaired(printer)" class="badge bg-secondary">No</span>
						</td>
						<td class="px-1 d-none d-lg-table-cell text-end">{{ printer.updated | shortDate }}</td>
						<td class="px-1 text-end">
							<div class="btn-group btn-group-sm" role="group">
								<button type="button" class="btn" 
									[ngClass]="isPosPrinter(printer) ? 'btn-success' : 'btn-outline-secondary'"
									(click)="togglePosPrinter(printer)" title="Impresora POS">
									POS
								</button>
								<button type="button" class="btn"
									[ngClass]="isKitchenPrinter(printer) ? 'btn-success' : 'btn-outline-secondary'"
									(click)="toggleKitchenPrinter(printer)" title="Impresora Cocina">
									Cocina
								</button>
							</div>
						</td>
						<td class="px-1 text-end">
							<a class="btn btn-sm btn-outline-primary me-1" [routerLink]="['/edit-printer-config', printer.id]">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
									<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
								</svg>
							</a>
							<button class="btn btn-sm btn-outline-danger" (click)="deletePrinter(printer)">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
									<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
									<path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
								</svg>
							</button>
						</td>
					</tr>
					<tr *ngIf="printer_list == null || printer_list.length == 0 && !is_loading">
						<td colspan="8">
							<div class="alert alert-light m-3" role="alert">No se encontraron impresoras configuradas</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<app-pagination [path]="'/list-printer-config'" [pages]="pages" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
</div>
